<template>
  <PageTemplate>
  <div class="in-content-warpper">
    <div class="row">
      <div class="des">
        <div class="title">
          图书检索系统 型号：HJ1
        </div>
        <el-row style="height:30px"></el-row>
        <p>1.通过账号、刷卡或微信扫码方式登录后查询个人信息，可查询内容有：我的借阅、续借信息、历史借阅等，可修改个人密码。</p>
        <el-row style="height:10px"></el-row>
        <p>2.图书检索：按照书名、作者信息、出版社、ISBN查询到图书，查询到的图书详细信息包括：书名、作者、借阅次数、索书号、馆藏位置、状态等信息。</p>
        <el-row style="height:10px"></el-row>
        <p>3.如果没有搜索条件，还可利用中图分类方法查阅相关图书，获取作者、ISBN号、索书号、馆藏定位等信息。</p>
        <el-row style="height:10px"></el-row>
        <p>4.通过图书检索系统界面了解图书馆发布的公告，如读者指南、入馆须知、活动等。</p>
        <el-row style="height:10px"></el-row>
        <p>5.支持安卓5.1系统或以上版本，安卓主板配置：存储：≥8G；内存：≥2G。</p>
        <el-row style="height:10px"></el-row>
        <p>6.21.5寸触摸屏，内含刷卡器。</p>
        <el-row style="height:10px"></el-row>
        <p>7.端口：LAN网线接口*1；USB端口*2；WIFI。</p>
      </div>
      <div class="img">
        <el-image :src="url1" fit="contain"></el-image>
      </div>
    </div>
  </div>
  </PageTemplate>
</template>
<script>
import PageTemplate from '@/components/PageTemplate'
export default {
  components:{PageTemplate},
  name: 'GuanLi',
  data () {
    return {
      url1: require('../assets/20220822_1.png')
    }
  },
  created () {
  },
  beforeDestroy () {
  }
}
</script>
<style lang="scss">
  .in-content-warpper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    .row {
      width: 100%;
      height: 500px;
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      align-items: center;
      .img {
        width: 500px;
        height: 340px;
        // background-color: #f2f2f2;
        .el-image {
          width: 500px;
          height: 340px;
        }
      }
      .des {
        width: 600px;
        text-align: left;
        margin-left: 100px;
        padding-top: 1;
        line-height: 1.2;
        .title{
          font-size: 25px;
          font-weight: 600;
          color: #000;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/1.vue